module.exports = __webpack_public_path__ + "img/characteristic2.72493fc1.png";